module.exports = __webpack_public_path__ + "img/socio0.ac09278f.png";